import { Serializer } from 'miragejs';

// https://github.com/miragejs/miragejs/issues/393
export default Serializer.extend({
  serializeIds: 'always',
  serialize(resource, request) {
    const json = Serializer.prototype.serialize.apply(this, [resource, request]);

    const root = this.keyForResource(resource);

    return json[root];
  },
});
